import React from 'react';
import { Container, Row, Col, Image } from 'react-bootstrap';
import Home from "../components/pages/Home";
import SchoolPicnic from '../components/pages/SchoolPicnic';
import CorporateEvent from '../components/pages/CorporateEvent';
import PrePostWedding from '../components/pages/PrePostWedding';
import FilmShooting from '../components/pages/FilmShooting';
import ContactUs from '../components/pages/ContactUs';
import CulturalPackage from '../components/pages/CulturalPackage';

const Footer = () => {
  return (
    <footer>
        <div className='cashless'>"Sorry" We Only Accept Cashless Payments </div>
    <div class="ftr-img img1"></div>
    <div class="ftr-img img4"></div>
    <div class="ftr-img img5"></div>
    <div class="ftr-img img3a"></div>
    <div class="ftr-img img3b"></div>
    <div class="container">
        <div class="sponsored-logos">
            <div class="sponsored-logos-in">
                <div class="clm1">
                    <div class="sponsored-wrap clearfix">
                        <div class="cl">
                            <h3>Sponsored - </h3></div>
                        <div class="cl"><Image src={`${process.env.PUBLIC_URL}/images/logo-sony-center.png`} fluid />
                            <p>Anna Nagar</p>
                        </div>
                        <div class="cl"><Image src={`${process.env.PUBLIC_URL}/images/logo-bosch.png`} fluid />
                            <p>Anna Nagar</p>
                        </div>
                        <div class="cl"><Image src={`${process.env.PUBLIC_URL}/images/logo-daikin.png`} fluid />
                            <p>Anna Nagar</p>
                        </div>
                    </div>
                    <div class="sponsored-wrap2">
                        <div class="cl">
                            <h4>Location</h4></div>
                        <div class="cl">Anna Nagar</div>
                        <div class="cl">Anna Nagar</div>
                        <div class="cl">Anna Nagar</div>
                    </div>
                </div>
                <div class="clm2">
                    <div class="more-info">
                        <p>For more info:</p>
                        <div class="ftr-contact-wrap">
                            <div class="btn-whatsapp">
                                <a href="https://wa.me/7667052339" target="_blank"><Image src={`${process.env.PUBLIC_URL}/images/ic-whatsapp3.png`} fluid /> 7667052339</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
             {/*<div class="checkout-row"><a href="javascript:;">WARE HOUSE PRICING SALE 10th to 31st Jan 2026</a></div> */}
            <div class="checkout-row"><a href="javascript:;">Check our 2026 "Guaranteed" Best Pricing Deal and Offers</a></div>
        </div>
        <div class="ftr-btm row">
            <div class="ftr-dt logo col-lg-3">
                <a href="/">
                    <figure class="ftr-logo"><Image src={`${process.env.PUBLIC_URL}/images/logo-ftr.png`} fluid /></figure>
                </a>
            </div>
            <div class="pt col-lg-2 col-md-6">
                <h3>Quick links</h3>
                <ul class="links">
                    <li><a href="/" class="hover-1">Home</a></li>
                    <li><a href="/GoogleReview" class="hover-1">Google Review</a></li>
                    <li><a href="/Packages" class="hover-1">Packages</a></li>
                    <li><a href="/GroupPackage" class="hover-1">Group Package</a></li>
                    <li><a href="/SchoolPicnic" class="hover-1">School Picnic</a></li>
                    <li><a href="/Photoshoot" class="hover-1">Photoshoot</a></li>
                    <li><a href="/ContactUs" class="hover-1">Contact Us</a></li>
                    <li><a href="/KeyInformation" class="hover-1">Key Information</a></li>
                    <li><a href="/AdvertiseWithUs" class="hover-1">Advertise with us</a></li>
                </ul>
            </div>
            <div class="pt col-lg-3 col-md-6">
                <h3>Address</h3>
                <p>NH-4, Near Queensland Theme Park, Kevlur Road Tandalam, Sriperumbudur,
                    <br />Chennai, Tamil Nadu 602105</p>
                <div class="btn-direction">
                    <a href="https://maps.app.goo.gl/YU6XZcUxq39hZkD67" target="_blank"><Image src={`${process.env.PUBLIC_URL}/images/ic-direction.png`} fluid /> Direction</a>
                </div>
            </div>
            <div class="pt last col-lg-4">
                <h3>Whatsapp</h3>
                <div class="ftr-contact-wrap">
                    <div class="btn-whatsapp">
                        <a href="https://wa.me/9884334346" target="_blank"><Image src={`${process.env.PUBLIC_URL}/images/ic-whatsapp3.png`} fluid /> 9884334346</a>
                    </div>
                    <div class="email">Email - <a href="mailto:trcnh4chennai@gmail.com" target="_blank">trcnh4chennai@gmail.com</a></div>
                </div>
            </div>
        </div>
    </div>
    <a href="/">
        <figure class="ftr-logo-mbl"><Image src={`${process.env.PUBLIC_URL}/images/logo-ftr.png`} fluid /></figure>
    </a>
    <div class="ftr-btm2">
        <div class="container">
            <div class="row">
                <div class="col-sm-6">
                    <p>©2026 ALL RIGHTS RESERVED.</p>
                </div>
                <div class="col-sm-6">
                    <ul class="links2">
                        <li><a href="/PrivacyPolicy">Privacy Policy</a></li>
                        <li><a href="/TermsAndConditions">T&amp;C</a></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</footer>
  );
};

export default Footer;